import type { FC } from 'react';

import { AsyncSelect } from '@zen/DesignSystem';
import type { Nullable } from '@zen/utils/typescript';

import { formatTerminalOrGroupLabel, isGroupMemberOption } from './helpers';
import useTerminalAndGroupOptions from './hooks/useTerminalAndGroupOptions';
import type { LoadTerminalAndGroupOptions, TerminalOrGroup, TerminalOrGroupOption } from './types';

interface Props {
  hasError?: boolean;
  includeGroups?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  name: string;
  onBlur?: () => void;
  onChange?: (value: Nullable<TerminalOrGroup>) => void;
  placeholder?: string;
  renderMenuInPortal?: boolean;
  value: Nullable<TerminalOrGroup>;
  variant?: 'default' | 'inline';
}

const TerminalsAndGroupsSelect: FC<Props> = (props) => {
  const { includeGroups = true, ...rest } = props;
  const loadOptions: LoadTerminalAndGroupOptions = useTerminalAndGroupOptions(includeGroups);

  return (
    <AsyncSelect<TerminalOrGroupOption>
      {...rest}
      defaultOptions={true}
      formatOptionLabel={formatTerminalOrGroupLabel}
      isOptionDisabled={isGroupMemberOption}
      loadOptions={loadOptions}
    />
  );
};

export type { Props as TerminalsAndGroupsSelectProps };

export default TerminalsAndGroupsSelect;
